<template>
    <div class="pie_config chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.pie.name!=='饼状图'">
            <span class="span_til">内半径</span>
            <el-input v-model="config.pie.nradius" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">%</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">外半径</span>
            <el-input v-model="config.pie.wradius" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">%</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">起始角度</span>
            <el-input v-model="config.pie.startAngle" @change="getRender" type="number"></el-input>
            <div class="unit">度</div>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.pie.clockwise" @change="getRender">是否顺时针排布</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">最小角度</span>
            <el-input v-model="config.pie.minAngle" @change="getRender" type="number" min="-360"></el-input>
            <div class="unit">度</div>
        </div>
        <div class="chartDivConfig selViewConfig" v-if="config.pie.name=='玫瑰图'">
            <span class="span_til">展示数据方式</span>
            <el-select v-model="config.pie.roseType" placeholder="请选择展示数据方式"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in roseTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.pie.label.show" @change="getRender">是否展示数据信息</el-checkbox>
        </div>
        <div v-if="config.pie.label.show">
            <div class="chartDivConfig selViewConfig" >
                <span class="span_til">数据信息位置</span>
                <el-select v-model="config.pie.label.position" placeholder="请选择数据信息位置"
                           :popper-append-to-body="false" @change="getRender">
                    <el-option
                            v-for="item in positionList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit">
                <span class="span_til ">名称字体大小</span>
                <el-input v-model="config.pie.label.rich.name.fontSize" @change="getRender" type="number" min="0"></el-input>
                <div class="unit">px</div>
            </div>
            <div class="chartDivConfig numViewConfig ">
                <span class="span_til ">名称字体粗细</span>
                <el-input v-model="config.pie.label.rich.name.fontWeight" @change="getRender" type="number" step="100" min="400"></el-input>
            </div>
            <div class="chartDivConfig colViewConfig">
                <span class="span_til ">名称字体颜色</span>
                <el-color-picker v-model="config.pie.label.rich.name.color" show-alpha @change="getRender"></el-color-picker>
            </div>
            <div class="chartDivConfig selViewConfig ">
                <span class="span_til ">数值格式</span>
                <el-select v-model="config.pie.numType" placeholder="请选择引导线类型"
                           :popper-append-to-body="false" @change="getRender">
                    <el-option
                            v-for="item in typeList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit">
                <span class="span_til">数值字体大小</span>
                <el-input v-model="config.pie.label.rich.value.fontSize" @change="getRender" type="number" min="0"></el-input>
                <div class="unit">px</div>
            </div>
            <div class="chartDivConfig numViewConfig ">
                <span class="span_til">数值字体粗细</span>
                <el-input v-model="config.pie.label.rich.value.fontWeight" @change="getRender" type="number" step="100" min="400"></el-input>
            </div>
            <div class="chartDivConfig colViewConfig">
                <span class="span_til ">数值字体颜色</span>
                <el-color-picker v-model="config.pie.label.rich.value.color" show-alpha @change="getRender"></el-color-picker>
            </div>
            <div class="chartDivConfig checkViewConfig">
                <el-checkbox v-model="config.pie.labelLine.show" @change="getRender">是否展示引导线</el-checkbox>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit">
                <span class="span_til span_tilMax">引导线第一段长度</span>
                <el-input v-model="config.pie.labelLine.length" @change="getRender" type="number" min="0"></el-input>
                <div class="unit">px</div>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit">
                <span class="span_til span_tilMax">引导线第二段长度</span>
                <el-input v-model="config.pie.labelLine.length2" @change="getRender" type="number" min="0"></el-input>
                <div class="unit">px</div>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit">
                <span class="span_til">引导线宽</span>
                <el-input v-model="config.pie.labelLine.lineStyle.width" @change="getRender" type="number" min="0"></el-input>
                <div class="unit">px</div>
            </div>
            <div class="chartDivConfig selViewConfig ">
                <span class="span_til ">引导线类型</span>
                <el-select v-model="config.pie.labelLine.lineStyle.type" placeholder="请选择引导线类型"
                           :popper-append-to-body="false" @change="getRender">
                    <el-option
                            v-for="item in lineList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="chartDivConfig colViewConfig">
                <span class="span_til ">引导线颜色</span>
                <el-color-picker v-model="config.pie.labelLine.lineStyle.color" show-alpha @change="getRender"></el-color-picker>
            </div>

        </div>

    </div>
</template>
<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'pie_config',
        components: {},
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                roseTypeList:[
                    {value: 'radius', label: '圆心角和半径展示数据'},
                    {value: 'area', label: '仅半径展示数据'},
                ],
                positionList: [
                    {value: 'outside', label: '扇区外侧'},
                    {value: 'center', label: '中心'},
                    {value: 'inside', label: '扇区内部'}
                ],
                lineList:[
                    {value: 'solid', name: '实线'},
                    {value: 'dashed', name: '虚线'},
                    {value: 'dotted', name: '点线'},
                ],
                typeList: [
                    {value: 'string', name: '百分数'},

                    {value: 'num', name: '数值'}
                ],
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .pie_config {
        .chartDivConfig {
            .span_til {
                max-width: 110px !important;
                width: 34% !important;
            }
            .span_tilMax {
                max-width: 120px !important;
                width: 46% !important;
            }
        }
    }
</style>
